import React from "react";
import "./Header.scss";
import Freadom from "assets/image/freadom-logo.svg";
import { Button } from "antd";

function Header() {
  return (
    <div className="header">
      <img src={Freadom} alt="logo" />
      <Button
        type="primary"
        size="default"
        onClick={() => window.open("/", "_blank")}
      >
        READ ON FREADOM
      </Button>
    </div>
  );
}

export default Header;
